import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How far in advance should we book Signature Occasions?",
  answer: "To ensure we can dedicate our full attention to your vision, we recommend booking at least 9 to 12 months in advance for weddings and 3 to 6 months for corporate galas or private parties."
}, {
  question: "Do you offer customizable planning packages?",
  answer: "Absolutely. While we have signature tiers, every event is unique. We tailor our services—from full-scale production to month-of coordination—to fit your specific needs and aesthetic goals."
}, {
  question: "Can you help with venue selection and vendor management?",
  answer: "Yes, our extensive network of premium partners allows us to source the most exclusive venues and reliable vendors, ensuring every detail aligns with our high standards of elegance and quality."
}, {
  question: "What types of events do you specialize in?",
  answer: "We specialize in high-end atmosphere creation for luxury weddings, sophisticated corporate milestones, and intimate private celebrations where detail and guest experience are paramount."
}, {
  question: "How do we begin the consultation process?",
  answer: "It starts with a complimentary discovery call. We'll discuss your inspiration, budget, and requirements to see how our signature approach can bring your dream occasion to life."
}];
export default function CommonInquiries() {
  return <section data-section-id="222313" id="common-inquiries" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-medium font-default text-primary tracking-tight mb-4">
            Common Inquiries
          </h2>
          <p className="text-lg text-muted-foreground font-sans tracking-wide">
            Discover the finer details of our planning process and how we curate your signature atmosphere.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border border-b">
              <AccordionTrigger className="text-foreground font-medium font-default text-lg md:text-xl hover:no-underline hover:text-primary/80 transition-all duration-300 text-left py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-sans text-base leading-relaxed tracking-wide pt-2 pb-8">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}